(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7186],{

/***/ 17285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 80354:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 16505:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(31032)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(12845)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(99402)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _sideEffect = _interop_require_default(__webpack_require__(70148));

var _ampContext = __webpack_require__(17285);

var _headManagerContext = __webpack_require__(60523);

var _ampMode = __webpack_require__(80354);

var _warnOnce = __webpack_require__(92783);

'use client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 70148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(99402)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref["delete"](props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 92783:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.warnOnce = void 0;

var warnOnce = function warnOnce(_) {};

if (false) { var warnings; }

exports.warnOnce = warnOnce;

/***/ }),

/***/ 51295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ usePushMerchantDataLayerEffect; },
/* harmony export */   "U": function() { return /* binding */ usePushPurchaseEventToDataLayer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _api_me__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71628);
/* harmony import */ var _utils_gtag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7788);



var usePushMerchantDataLayerEffect = function usePushMerchantDataLayerEffect(params) {
  var _useUserMe = (0,_api_me__WEBPACK_IMPORTED_MODULE_1__/* .useUserMe */ .J1)(),
      user = _useUserMe.user,
      isUserLoading = _useUserMe.isUserLoading;

  var loginMerchantId = (user === null || user === void 0 ? void 0 : user.role) === 'admin' ? user.id : undefined;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isUserLoading) return;
    window.gtmDataLayer = window.gtmDataLayer || [];
    window.gtmDataLayer.push({
      login_user_id: user === null || user === void 0 ? void 0 : user.id,
      visit_merchant_id: params.visit_merchant_id,
      login_merchant_id: loginMerchantId
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      login_user_id: user === null || user === void 0 ? void 0 : user.id,
      visit_merchant_id: params.visit_merchant_id,
      login_merchant_id: loginMerchantId
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isUserLoading]);
};
var usePushPurchaseEventToDataLayer = function usePushPurchaseEventToDataLayer(params) {
  var isPurchaseEventSent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!isPurchaseEventSent.current) {
      _utils_gtag__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEvent */ .mG({
        step: 'completion',
        productPublicId: params.productId,
        customerPublicId: params.customerId
      });
      isPurchaseEventSent.current = true;
    }
  });
};

/***/ }),

/***/ 88501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _templates_merchants_widget_calendar_IndexTemplate_MerchantWidgetCalendarPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39890);
/* harmony import */ var _redux_actions_merchants_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86504);
/* harmony import */ var _components_layouts_MetaTags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84915);
/* harmony import */ var _templates_ErrorTemplate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80806);
/* harmony import */ var _components_MerchantSite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7818);
/* harmony import */ var _hooks_gtm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51295);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74883);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);











var FromTypes = {
  DAY: 'agendaDay',
  THREE_DAY: 'agendaThreeDay',
  WEEK: 'agendaWeek',
  MONTH: 'month',
  LIST: 'listMonth'
};

var MerchantWidgetCalendar = function MerchantWidgetCalendar(props) {
  var merchantPublicId = props.merchantPublicId,
      merchantDetail = props.merchantDetail,
      calendarViewStyle = props.calendarViewStyle,
      ga = props.ga,
      servicePublicIds = props.servicePublicIds,
      isUnpublishedSite = props.isUnpublishedSite,
      isCoubicApp = props.isCoubicApp,
      utm_campaign = props.utm_campaign,
      utm_medium = props.utm_medium,
      utm_source = props.utm_source,
      ga_client_id = props.ga_client_id,
      ga_session_id = props.ga_session_id;
  var dispatch = (0,_redux__WEBPACK_IMPORTED_MODULE_7__/* .useAppDispatch */ .TL)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _merchantDetail$time_;

    dispatch((0,_redux_actions_merchants_services__WEBPACK_IMPORTED_MODULE_2__/* .init */ .S1)(merchantPublicId, (_merchantDetail$time_ = merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.time_zone) !== null && _merchantDetail$time_ !== void 0 ? _merchantDetail$time_ : 'Asia/Tokyo'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  (0,_hooks_gtm__WEBPACK_IMPORTED_MODULE_6__/* .usePushMerchantDataLayerEffect */ .O)({
    visit_merchant_id: merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.id
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_MerchantSite__WEBPACK_IMPORTED_MODULE_5__/* .MerchantSite */ .Z, {
    isUnPublished: isUnpublishedSite,
    isMerchantInfoExist: !!merchantDetail,
    logoImage: (merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.logo_image) || null,
    merchantPublicId: (merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.public_id) || null,
    isCoubicApp: isCoubicApp,
    children: merchantDetail ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("style", {
        children: "body {\n                min-width: 100% !important;\n              }\n\n              .fc .fc-daygrid-body-natural .fc-daygrid-day-events {\n                margin-bottom: 0px !important;\n              }\n\n              .fc .fc-daygrid-event-harness .fc-daygrid-event .fc-event-main-frame {\n                padding: 0 !important;\n              }\n\n              .fc-col-header-cell-cushion {\n                font-size: 12px;\n              }\n\n              .fc .fc-toolbar h2 {\n                font-size: 100%;\n              }\n\n              .fc .fc-toolbar {\n                flex-wrap: wrap;\n                flex-direction: row;\n              }\n\n              @media screen and (max-width:480px) {\n                .fc-toolbar-chunk {\n                  margin-top: 15px;\n                }\n              }\n          "
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_layouts_MetaTags__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        noIndex: true,
        googleAnalyticsFourTrackingId: merchantDetail.available_google_analytics_four_tracking_id
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_templates_merchants_widget_calendar_IndexTemplate_MerchantWidgetCalendarPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        merchantDetail: merchantDetail,
        calendarViewStyle: calendarViewStyle,
        ga: ga,
        servicePublicIds: servicePublicIds,
        utm_campaign: utm_campaign,
        utm_medium: utm_medium,
        utm_source: utm_source,
        ga_client_id: ga_client_id,
        ga_session_id: ga_session_id
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_templates_ErrorTemplate__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      statusCode: 404
    })
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (MerchantWidgetCalendar);

/***/ }),

/***/ 39890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66338);
/* harmony import */ var _redux_actions_merchants_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86504);
/* harmony import */ var _redux_types_merchants_services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var MerchantWidgetCalendar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4870), __webpack_require__.e(2438), __webpack_require__.e(7219)]).then(__webpack_require__.bind(__webpack_require__, 67219)).then(function (c) {
    return c["default"];
  });
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {});
  },
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(67219)];
    }
  }
});

var MerchantWidgetCalendarPage = function MerchantWidgetCalendarPage(_ref) {
  var baseDate = _ref.baseDate,
      merchantDetail = _ref.merchantDetail,
      calendarViewStyle = _ref.calendarViewStyle,
      ga = _ref.ga,
      servicePublicIds = _ref.servicePublicIds,
      utm_campaign = _ref.utm_campaign,
      utm_medium = _ref.utm_medium,
      utm_source = _ref.utm_source,
      ga_client_id = _ref.ga_client_id,
      ga_session_id = _ref.ga_session_id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(MerchantWidgetCalendar, {
    merchantPublicId: merchantDetail.public_id,
    merchantTimeZone: merchantDetail.time_zone,
    baseDate: baseDate,
    business_hours: merchantDetail.business_hours,
    calendarViewStyle: calendarViewStyle,
    ga: ga,
    servicePublicIds: servicePublicIds,
    googleAnalyticsFourTrackingId: merchantDetail.available_google_analytics_four_tracking_id,
    utm_campaign: utm_campaign,
    utm_medium: utm_medium,
    utm_source: utm_source,
    ga_client_id: ga_client_id,
    ga_session_id: ga_session_id
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return _objectSpread({}, state.merchantsServices);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: {
      handleCalendarClick: function handleCalendarClick() {
        return dispatch(_redux_actions_merchants_services__WEBPACK_IMPORTED_MODULE_4__/* .ActionsCreators.switchViewStyle */ .If.switchViewStyle(_redux_types_merchants_services__WEBPACK_IMPORTED_MODULE_5__/* .ViewStyle.Calendar */ .p.Calendar));
      },
      handleListClick: function handleListClick() {
        return dispatch(_redux_actions_merchants_services__WEBPACK_IMPORTED_MODULE_4__/* .ActionsCreators.switchViewStyle */ .If.switchViewStyle(_redux_types_merchants_services__WEBPACK_IMPORTED_MODULE_5__/* .ViewStyle.List */ .p.List));
      },
      moveNext: function moveNext() {
        return dispatch(_redux_actions_merchants_services__WEBPACK_IMPORTED_MODULE_4__/* .ActionsCreators.moveNext */ .If.moveNext());
      },
      movePrev: function movePrev() {
        return dispatch(_redux_actions_merchants_services__WEBPACK_IMPORTED_MODULE_4__/* .ActionsCreators.movePrev */ .If.movePrev());
      },
      load: function load(publicId, baseDate, fetchedUntil) {
        _redux_actions_merchants_services__WEBPACK_IMPORTED_MODULE_4__/* .ActionsCreators.load */ .If.load(publicId, baseDate, fetchedUntil).then(function (ac) {
          return ac && dispatch(ac);
        });
      },
      scrollNext: function scrollNext() {
        dispatch(_redux_actions_merchants_services__WEBPACK_IMPORTED_MODULE_4__/* .ActionsCreators.scrollNext */ .If.scrollNext());
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(MerchantWidgetCalendarPage));

/***/ }),

/***/ 33220:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/widget/calendar",
      function () {
        return __webpack_require__(88501);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ }),

/***/ 86896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1966,2187,9836,4604,806,1800,9774,2888,179], function() { return __webpack_exec__(33220); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);